import { useNavigate } from "react-router-dom";

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <a href="/admin" className="absolute top-4 right-4 text-sm text-slate-500 hover:text-[#109FE9] transition-colors" data-testid="home-admin-link">
        Admin Login
      </a>
      <div className="w-full max-w-md space-y-6 text-center">
        <img
          src="https://customer-assets.emergentagent.com/job_pool-lesson-book/artifacts/c9s2nl0s_rr%20logo.png"
          alt="Rolling River Day Camp"
          className="w-24 h-24 mx-auto"
        />
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-[#2B4C8C]">
          Rolling River Day Camp
        </h1>
        <p className="text-slate-600 text-lg">Private Swim Lessons</p>

        <div className="space-y-4 pt-4">
          <button
            data-testid="enrolled-btn"
            onClick={() => navigate("/register")}
            className="w-full py-5 px-6 rounded-2xl bg-[#2B4C8C] hover:bg-[#1e3666] text-white font-bold text-lg transition-all shadow-lg hover:shadow-xl"
          >
            July-August Lessons (In Season)
            <span className="block text-sm font-normal opacity-80 mt-1">Rolling River Campers Only</span>
          </button>

          <button
            data-testid="non-enrolled-btn"
            onClick={() => navigate("/non-enrolled")}
            className="w-full py-5 px-6 rounded-2xl bg-[#D4A843] hover:bg-[#b8902e] text-white font-bold text-lg transition-all shadow-lg hover:shadow-xl"
          >
            Pre Season
            <span className="block text-sm font-normal opacity-80 mt-1">Open To Anyone</span>
          </button>
        </div>
      </div>
    </div>
  );
}
